import React from "react";
import { FormattedMessage } from "react-intl";
import Widget from "./Widget";

const OpenQuiz = props => (
  <div>
    {props.quiz ? (
      <Widget
        {...props}
        onChange={e => props.onOpenQuizChange(e.target.value)}
        onSubmit={() => props.onSubmit()}
      />
    ) : (
      <FormattedMessage id="globals.loading" />
    )}
  </div>
);

export default OpenQuiz;
